module.exports = __webpack_public_path__ + "static/media/dice-two.87446ed7.svg";